<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="Collection point login">
                <mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>
                <!--<mt-button slot="right" @click="goRegister">加盟</mt-button>-->
            </mt-header>
        </div>
        <div class="top-wrapper">
            <div>
                <mt-field class="input-wrapper" v-model="chain_name" placeholder="Collection point account" type="text" />
            </div>
            <div>
                <mt-field type="password" class="input-wrapper" v-model="password" placeholder="Please enter the password" maxlength="20" />
            </div>
        </div>
        <mt-button type="primary" class="ds-button-large mt-10 mb-10" v-on:click="signin">Sign in</mt-button>
    </div>
</template>

<script>
import { chainLogin } from '../../../api/chainLogin'
import { Indicator, Toast } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  name: 'login',
  data () {
    return {
      chain_name: '',
      password: ''
    }
  },
  created: function () {
    Indicator.close()
    if (this.$route.query.clear) {
      this.chainLogout()
    }
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'chainLogin',
      chainLogout: 'chainLogout'
    }),
    goRegister () {
      this.$router.push({ name: 'ChainRegister' })
    },
    signin () {
      let chain_name = this.chain_name
      let password = this.password
      if (chain_name.length === 0) {
        Toast('Please enter user name')
        return
      }
      // TODO: 用户名（为手机号或邮箱）校验
      if (password.length === 0) {
        Toast('Please enter the password')
        return
      }
      if (password.length < 6) {
        Toast('Enter at least 6 digits password')
        return
      }
      Indicator.open()
        chainLogin(chain_name, password).then(
        response => {
          Indicator.close()
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          this.goChainIndex()
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    goChainIndex () {
      this.$router.push({ name: 'ChainIndex' })
    }
  }
}
</script>

<style scoped lang='scss'>
    .container {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #F0F2F5;
        .top-wrapper {
            .input-wrapper {
                display: flex;
                align-content: center;
                align-items: center;
                padding-left: 0.5rem;
                background-color: #fff;
                height: 2.2rem;
                img {
                    width: 1.2rem;
                    height: 1.2rem;
                    margin: 0;
                    padding: 0;
                }
                input {
                    flex: 1;
                    font-size:.7rem;
                }
                .bottom-input {
                    border-bottom-width: 0;
                }
            }
        }
    }
</style>
